import { useContext, useState } from "react";
import GenericBody from "../Componentes/GenericBody";
import NavBar from "../Componentes/NavBar";
import Overlay from "../Componentes/Overlay";
import SideMenu from "../Componentes/SideMenu";
import SideMenuBtn from "../Componentes/SideMenuBtn";
import { useModal } from "../contexts/ModalContext";
import ConteudoCorpo from "../Modulos/Treinamentos/catalogo/ConteudoCorpo";
import ModalAddTreinamento from "../Modulos/Treinamentos/catalogo/ModalAddTreinamento";
import { VerifyPermission } from "../Funcoes/VerifyPermission";
import { AuthContext } from "../Auth/AuthProvider";
import { useNavigate } from "react-router-dom";

const CatalogoTreinamentos = () => {

    const { user } = useContext(AuthContext);

    const { openModal, closeModal, isModalOpen } = useModal();

    const [atualizarConteudo, setAtualizarConteudo] = useState(false);

    const navigate = useNavigate();

    const triggerUpdateConteudo = () => {

        setAtualizarConteudo(prev => !prev);
        closeModal();

    }

    const novoTreinamento = () => {

        if( VerifyPermission(user, { modulo: 'ssma', submodulo: 'treinamentos', funcao: 'editar_catalogo' }) === false ) {
            alert("Você não tem permissão para adicionar treinamentos ao catálogo.");
            return;
        }

        closeModal();
        openModal("addTreinamento");

    }

    return (
        <>
            <NavBar title="CATÁLOGO TREINAMENTOS" changeState={() => openModal("sidebar")} prevDest="modulo/ssma/treinamentos" />
            <GenericBody>
                <ConteudoCorpo atualizar={atualizarConteudo} />
            </GenericBody>

            {
                isModalOpen("sidebar") && (
                    <Overlay state={true} changeState={() => closeModal()} >
                        <SideMenu>
                            {
                                VerifyPermission(user, { modulo: 'ssma', submodulo: 'treinamentos', funcao: 'editar_catalogo' }) && (
                                    <SideMenuBtn
                                        button="ADICIONAR TREINAMENTO"
                                        clickFunc={novoTreinamento}
                                    />
                                )
                            }
                            <SideMenuBtn
                                button="FUNÇÃO x O.S."
                                clickFunc={() => navigate("/modulo/ssma/treinamentos/catalogo/funcao-os")}
                            />
                        </SideMenu>
                    </Overlay>
                )
            }
            {
                isModalOpen("addTreinamento") && (
                    <ModalAddTreinamento modo="create" onSuccess={triggerUpdateConteudo} />
                )
            }
        </>
    )
}

export default CatalogoTreinamentos;